import $ from 'jquery'
import ModeAdministration from '@/views/parametres/mode-administration'
import ExcelModal from '@/views/parametres/import-excel-modal'

export default {
    name: 'tarif-actes',
    components: {
        ModeAdministration, ExcelModal
    },
    props: [],
    data() {
        return {
            soin_loading: true,
            soin_empty: false,

            acte_loading: true,
            acte_empty: false,

            autre_acte_loading: true,
            autre_acte_empty: false,

            soins_fields: [
				'libelle', 'acte', 'prix', 'actions'
			],
			filter: "",

            acte_fields: [
				'libelle', 'prix', 'actions'
			],
            acte_filter: "",
			autre_acte_filter: "",

			perPage: 20,
			currentPage: 1,

            modal_title: '',

            acte_data: {
                type_acte: '',
                id: 0,
                acte: '',
                prix: ''
            },

            soin_data: {
                id: 0,
                libelle: '',
                acte: '',
            },

            btn_disable: false,
            save_loading: false,

            // >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
            del_disable: false,

            type_del: '',

            is_printing_acte: false,
            is_printing_soin: false,
            filename: '',
            is_soin: true,

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix'
            },

            json_data: [],
            export_filename: 'Liste_Acte.xls',
            can_print: false,
            acte_loading_percentage: 0,
            can_view_percentage: false,
            acte_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        tarif_soin_actes() {
            return this.$store.getters["tarif_soin_actes"];
        },

        tarif_actes() {
            return this.$store.getters["tarif_actes"];
        },

        tarif_autre_actes() {
            return this.$store.getters["tarif_autre_actes"];
        },
    },

    mounted() {
        // Liste des soins
        this.getListeSoins()

        // Liste des actes
        this.getListeActes()

        // Liste des autres actes
        this.getListeAutreActes()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_acte_soins_'+tmpstamp
    },

    beforeDestroy() {
        if (this.acte_refresh_timeout_id) {
            clearTimeout(this.acte_refresh_timeout_id)
            this.acte_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },
    
    methods: {
        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListActe'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * Liste actes de soins
         */
        getListeSoins() {
            this.soin_loading = true
            this.$store.dispatch('getTarifSoins').then(() => {
                if (this.tarif_soin_actes.length > 0) {
                    this.soin_empty = false
                } else {
                    this.soin_empty = true
                }
                this.soin_loading = false
            })
        },

        countdownLoad() {
            const TOTAL_SECONDS = 4 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.acte_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.acte_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.acte_loading_percentage = 0
                }
            }, 1000)
        },

        refreshListeActe() {
            this.acte_loading = true
            this.can_view_percentage = true
            if (this.acte_refresh_timeout_id) {
                clearTimeout(this.acte_refresh_timeout_id)
                this.acte_refresh_timeout_id = null
            }

            if (this.tarif_actes.length > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getListeActes()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getListeActes()
            this.acte_refresh_timeout_id = setTimeout(() => {
                this.refreshListeActe()
            }, 5000)
        },

        loadEmitAction() {
            this.countdownLoad()
            this.refreshListeActe()
        },

        getListeActes() {
            this.acte_loading = true
            this.json_data = []
            this.$store.dispatch('getTarifActes', 'acte').then(() => {
                if (this.tarif_actes.length > 0) {
                    this.acte_empty = false

                    this.tarif_actes.forEach(tarif_acte => {
                        this.json_data.push({
                            'libelle' : tarif_acte.acte,
                            'prix' : (tarif_acte.prix > 0)?tarif_acte.prix:''
                        })
                    });
                } else {
                    this.acte_empty = true
                }

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.acte_loading = false
                    }
                } else {
                    this.acte_loading = false
                }
            })
        },

        getListeAutreActes() {
            this.autre_acte_loading = true
            this.$store.dispatch('getTarifActes', 'autre_acte').then(() => {
                if (this.tarif_autre_actes.length > 0) {
                    this.autre_acte_empty = false
                } else {
                    this.autre_acte_empty = true
                }
                this.autre_acte_loading = false
            })
        },

        addActe(type_acte) {
            this.modal_title = "Nouvel acte"

            this.acte_data = {
                type_acte: '',
                id: 0,
                acte: '',
                prix: ''
            }
            this.$refs.observer.reset();

            this.acte_data.type_acte = type_acte
        },

        editActe(data) {
            this.modal_title = data.acte

            this.acte_data = {
                type_acte: data.type_acte,
                id: data.id,
                acte: data.acte,
                prix: data.prix
            }
        },

        editSoin(data) {
            this.modal_title = data.libelle

            this.soin_data = {
                id: data.id,
                libelle: data.libelle,
                acte: {
                    id: data.acte_id,
                    acte: data.acte
                },
            }
        },

        addSoin() {
            this.modal_title = "Nouveau soin"

            this.soin_data = {
                id: 0,
                libelle: '',
                acte: '',
            }
            this.$refs.observer.reset();
        },

        async submitActe() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch('saveActe', this.acte_data).then((response) => {
                if (response > 0) {
                    if (this.acte_data.id == 0) {
                        this.successMsg('Acte ajouté avec succès')
                    } else {
                        this.successMsg('Acte modifié avec succès')
                    }
                    

                    if (this.acte_data.type_acte == 'acte') {
                        this.getListeActes()
                    } else {
                        this.getListeAutreActes()
                    }

                    this.acte_data = {
                        type_acte: '',
                        id: 0,
                        acte: '',
                        prix: ''
                    }
                    this.$refs.observer.reset();

                    $('.modal').modal('hide')
                    
                }

                this.save_loading = false
                this.btn_disable = false
            })
        },

        async submitSoin() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch('saveSoin', this.soin_data).then((response) => {
                if (response > 0) {
                    this.soin_data = {
                        id: 0,
                        libelle: '',
                        acte: '',
                    }
                    this.$refs.observer.reset();
                    $('.modal').modal('hide')

                    if (this.soin_data.id == 0) {
                        this.successMsg('Soin ajouté avec succès')
                    } else {
                        this.successMsg('Soin modifié avec succès')
                    }
                    this.getListeSoins()
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data, type) {
            this.type_del = type

            console.log("--> ",type, data)

            if (type == 'acte') {
                this.tarif_to_be_deleted = {
                    id: data.id,
                    libelle: data.acte,
                    type: data.type_acte,
                }
            } else {
                this.tarif_to_be_deleted = {
                    id: data.id,
                    libelle: data.libelle,
                    type: '',
                }
            }
			
		},

        /**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true
            this.del_disable = true
            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false
                this.del_disable = false
            }

            if (err == 0) {
                if (this.type_del == 'acte') {
                    this.$store.dispatch('deleteActe', this.tarif_to_be_deleted).then((response) => {
                        
                        if (response > 0) {
                            this.successMsg('Acte supprimé avec succès')

                            if (this.tarif_to_be_deleted.type == 'acte') {
                                this.getListeActes()
                            } else {
                                this.getListeAutreActes()
                            }
                        }

                        $('.modal').modal('hide')
                        this.del_loading = false;
                        this.is_confirm = false
                        this.del_disable = false
                    })
                } else {
                    this.$store.dispatch('deleteSoin', this.tarif_to_be_deleted).then((response) => {
                        
                        if (response > 0) {
                            this.successMsg('Soin supprimé avec succès')

                            this.getListeSoins()
                        }

                        $('.modal').modal('hide')
                        this.del_loading = false;
                        this.is_confirm = false
                        this.del_disable = false
                    })
                }
            }
        },

        printSoinActe(v) {
            this.is_soin = v

            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Acte_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },
    }
}


